



















import Vue from 'vue';
import router from '../../router';

export default Vue.extend({
  name: 'Navbar',
  data() {
    return {
      logo: require('../../assets/logo.png'),
    };
  },
  methods: {
    toTop() {
      router.push('/');
    },
    toHistories() {
      router.push('/histories');
    },
    toUpload() {
      router.push('/upload');
    },
  },
});
